import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadStats } from '../../../redux';
import { useLocation } from 'react-router-dom';
import StatsForm from "../StatsForm/StatsForm";
import StatsMovies from '../StatsMovies/StatsMovies';
import StatsPrices from '../StatsPrices/StatsPrices';
import StatsRooms from '../StatsRooms/StatsRooms';
import StatsDaily from '../StatsDaily/StatsDaily';
import StatsHourly from '../StatsHourly/StatsHourly';
import StatsBoxOffice from '../StatsBoxOffice/StatsBoxOffice';
import StatsCarts from '../StatsCarts/StatsCarts';
import moment from 'moment';

import './StatstypesList.css';
import StatsAccounting from "../StatsAccounting/StatsAccounting";

const StatstypeList = () => {
    const dispatch                        = useDispatch();
    const location                        = useLocation();
    const [statsState, setStatsState]     = useState('')
    const [stateFilters, setStateFilters] = useState(null)
    const { isLoading }                   = useSelector(state => state.stats);

    const loadStatsFromServer = (filters) => {
        if (statsState !== "")
            dispatch(loadStats(statsState, getSerializedFilters(filters)));
    };

    const getSerializedFilters = (filters) => {
        const startDate = filters?.start_date instanceof moment ?
                          filters.start_date :
                          moment();

        const endDate   = filters?.end_date instanceof moment ?
                          filters.end_date :
                          moment();

        return {
            ...filters,
            start_date: startDate.toISOString(),
            end_date: endDate.toISOString()
        };
    }

    const onSubmit = (filtersFromChild) => {
        setStateFilters(filtersFromChild);
        loadStatsFromServer(filtersFromChild);
    }

    useEffect(() => {
        if (stateFilters)
            loadStatsFromServer(stateFilters);
    }, [statsState, stateFilters]);

    useEffect(() => {
        switch (location.pathname) {
            case "/stats/movies":
                setStatsState('movies')
                break;
            case "/stats/prices":
                setStatsState('prices')
                break;
            case "/stats/places":
                setStatsState('places')
                break;
            case "/stats/days":
                setStatsState('days')
                break;
            case "/stats/hours":
                setStatsState('hours')
                break;
            case "/stats/box_office":
                setStatsState('box_office')
                break;
            case "/stats/accounting":
                setStatsState('accounting');
                break;
        }
    })

    const serializedFilters = useMemo(() =>
        getSerializedFilters(stateFilters)
    , [stateFilters]);

    return (
      <div className="StatstypesList">
          {statsState === 'accounting' ? (
            <StatsAccounting
              filters={serializedFilters}
              onSubmit={onSubmit}
            />
          ) : (
            <StatsForm isLoading={isLoading} onSubmittedForm={onSubmit} />
          )}

          {!isLoading && statsState !== 'accounting' && (
            {   //this is a switch, it will show component relative to StatsState
                'movies'    : <StatsMovies filters={serializedFilters} />,
                'prices'    : <StatsPrices filters={serializedFilters} />,
                'places'    : <StatsRooms filters={serializedFilters} />,
                'days'      : <StatsDaily filters={serializedFilters} />,
                'hours'     : <StatsHourly filters={serializedFilters} />,
                'box_office': <StatsBoxOffice filters={serializedFilters} />,
                'carts'     : <StatsCarts filters={serializedFilters} />
            }[statsState]
          )}
      </div>
    );
}

export default StatstypeList;
